// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseButton_close__8HgLM","icon":"CloseButton_icon__9jX2T"};